var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.135 22.238h-3.927v-6.32c0-1.589-.568-2.673-1.988-2.673a2.15 2.15 0 00-2.015 1.438c-.101.309-.145.633-.13.957v6.598h-3.927c0-.007.052-10.707 0-11.815h3.928v1.674a3.896 3.896 0 013.538-1.951c2.583 0 4.521 1.689 4.521 5.318v6.774zM6.012 8.81h-.025a2.047 2.047 0 11.051-4.083 2.048 2.048 0 11-.026 4.083zM4.048 22.238h3.927V10.423H4.048v11.815zM24.171.5H2.015A1.9 1.9 0 00.093 2.374v22.253A1.898 1.898 0 002.015 26.5H24.17a1.897 1.897 0 001.922-1.873V2.374A1.899 1.899 0 0024.17.5z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}
export default __webpack_public_path__ + "c6b26b6a73e663506c89d37dbc750452.svg";
export { SvgLinkedin as ReactComponent };